import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { StaticAssetPipe } from '@rma/generic/util/pipes/static-asset-url';
import { PromotionBannerStyle } from '../orc-promotion-banner/promotion-banner-style.enum';

@Component({
  selector: 'rma-march-madness-banner',
  templateUrl: './march-madness-banner.component.html',
  styleUrls: ['./march-madness-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, RouterModule, StaticAssetPipe],
})
export class MarchMadnessBannerComponent {
  @Input({ required: true })
  bannerStyle: PromotionBannerStyle = 'Full';
}
